// Modules
import React from 'react'
import { Button } from '@dasa-health/components-react'
import { Flex, Spacing } from '@dasa-health/alma-react'

// Application
import { CustomModal } from 'redesign/components/atoms/CustomModal'
import { userDeviceDetect } from 'utils'
import { useCPFLoginForm } from 'redesign/hooks/useCPFLoginForm'

type ModalCipProps = {
    setShowModal: (value: boolean) => void
    showModal: boolean
}

export const ModalCip = ({ setShowModal, showModal }: ModalCipProps) => {
    const { isPortable } = userDeviceDetect()
    const { redirectToLoginProtocol } = useCPFLoginForm()
    return (
        <CustomModal onClose={() => setShowModal(false)} open={showModal} showCloseButton={false} title="Atenção">
            <p>
                Ao acessar com protocolo (CIP), você consegue apenas visualizar seus exames. Para ter acesso completo do Nav Dasa como
                consulta online, agendamentos, entre outras funcionalidades, preciso que acesse via CPF. Como deseja continuar?
            </p>

            <Spacing height={24} />
            {isPortable ? (
                <>
                    <Button onClick={() => setShowModal(false)} type="button" width="100%">
                        Acessar via CPF
                    </Button>
                    <Spacing height={16} />
                    <Button onClick={redirectToLoginProtocol} type="button" variant="tertiary" width="100%">
                        Acessar via protocolo (CIP)
                    </Button>
                </>
            ) : (
                <Flex>
                    <Button onClick={redirectToLoginProtocol} type="button" variant="tertiary" width="100%">
                        Acessar via protocolo (CIP)
                    </Button>
                    <Spacing width={16} />
                    <Button onClick={() => setShowModal(false)} type="button" width="100%">
                        Acessar via CPF
                    </Button>
                </Flex>
            )}
        </CustomModal>
    )
}
